<div class="rider-container mat-elevation-z2">
  <div class="header">
    <h2>Riders</h2>
    <button mat-flat-button color="primary" (click)="openDialog()">Add Rider</button>
  </div>

  <div class="analytics-grid" *ngIf="analytics">
    <div class="card">
      <div class="title">Opened Phone Logs</div>
      <div class="value">{{ analytics.openedCount }}/{{ analytics.totalRiders }}</div>
    </div>
    <div class="card">
      <div class="title">Closed Phone Logs</div>
      <div class="value">{{ analytics.closedCount }}</div>
    </div>
    <div class="card warn">
      <div class="title">Pending Close</div>
      <div class="value">{{ analytics.pendingCloseCount }}</div>
    </div>
    <div class="card">
      <div class="title">Total Credit Used</div>
      <div class="value">{{ analytics.totalCreditUsed | number:'1.0-2' }}</div>
    </div>
    <div class="card">
      <div class="title">Avg Credit Used</div>
      <div class="value">{{ analytics.averageCreditUsed | number:'1.0-2' }}</div>
    </div>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <table mat-table [dataSource]="dataSource" class="mat-elevation-z1 full-width-table">
    <ng-container matColumnDef="fullName">
      <th mat-header-cell *matHeaderCellDef>Full Name</th>
      <td mat-cell *matCellDef="let r">{{ r.fullName }}</td>
    </ng-container>

    <ng-container matColumnDef="phoneNumber">
      <th mat-header-cell *matHeaderCellDef>Phone</th>
      <td mat-cell *matCellDef="let r">{{ r.phoneNumber }}</td>
    </ng-container>

    <ng-container matColumnDef="assignedPhoneModel">
      <th mat-header-cell *matHeaderCellDef>Assigned Phone</th>
      <td mat-cell *matCellDef="let r">{{ r.assignedPhoneModel || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="assignedPhoneNumber">
      <th mat-header-cell *matHeaderCellDef>Work SIM</th>
      <td mat-cell *matCellDef="let r">{{ r.assignedPhoneNumber || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="startPhoneState">
      <th mat-header-cell *matHeaderCellDef>Start Phone State</th>
      <td mat-cell *matCellDef="let r">{{ r.startPhoneState || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="startCreditAmount">
      <th mat-header-cell *matHeaderCellDef>Start Credit</th>
      <td mat-cell *matCellDef="let r">{{ r.startCreditAmount ?? '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="endCreditAmount">
      <th mat-header-cell *matHeaderCellDef>End Credit</th>
      <td mat-cell *matCellDef="let r">{{ r.endCreditAmount ?? '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="creditUsed">
      <th mat-header-cell *matHeaderCellDef>Credit Used</th>
      <td mat-cell *matCellDef="let r">{{ r.creditUsed ?? '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="isActive">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let r">
        <span class="status" [ngClass]="r.isActive ? 'active' : 'inactive'">
          {{ r.isActive ? 'Active' : 'Inactive' }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="phoneActions">
      <th mat-header-cell *matHeaderCellDef>Phone Logs</th>
      <td mat-cell *matCellDef="let r">
        <button mat-icon-button [matMenuTriggerFor]="phoneLogMenu" matTooltip="Phone Log Actions">
          <mat-icon>menu</mat-icon>
        </button>
        <mat-menu #phoneLogMenu="matMenu">
          <button mat-menu-item (click)="openPhoneWork(r)" [disabled]="!!r.startCreditAmount">
            <mat-icon>play_circle</mat-icon>
            <span>Open Work</span>
          </button>
          <button mat-menu-item (click)="closePhoneWork(r)" [disabled]="!r.startCreditAmount || !!r.endCreditAmount">
            <mat-icon>stop_circle</mat-icon>
            <span>Close Work</span>
          </button>
          <button mat-menu-item (click)="editPhoneLog(r)" [disabled]="!r.phoneLogId || !r.canEditPhoneLog">
            <mat-icon>edit</mat-icon>
            <span>Edit Phone Log</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let r">
        <button mat-icon-button [matMenuTriggerFor]="riderActionsMenu" matTooltip="Rider Actions">
          <mat-icon>menu</mat-icon>
        </button>
        <mat-menu #riderActionsMenu="matMenu">
          <button mat-menu-item (click)="openDialog(r)">
            <mat-icon>edit</mat-icon>
            <span>Edit Rider</span>
          </button>
          <button mat-menu-item (click)="toggleStatus(r)">
            <mat-icon>sync</mat-icon>
            <span>Toggle Status</span>
          </button>
          <button mat-menu-item (click)="deleteRider(r.id)">
            <mat-icon>delete</mat-icon>
            <span>Delete Rider</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
</div>
